<template>
  <v-row no-gutters class="fill-height flex-column">
    <v-col>
      <v-row no-gutters>
        <v-col cols="1"> </v-col>
        <v-col cols="auto">
          <v-subheader class="text-h6 font--text px-0 py-6" style="height: auto;" v-text="$i18n.t('map.coordinates')">
          </v-subheader>
        </v-col>
      </v-row>
      <v-row no-gutters class="align-baseline">
        <v-col cols="1">
          <v-icon color="rgba(0,0,0,0.7)" size="21">
            mdi-map-marker-plus
          </v-icon>
        </v-col>
        <v-col cols="10" class="border pb-4">
          <base-button-subheader
            v-if="!isCoordinatesToolActive"
            @click="addCoordinatesInteraction"
            translation-path="map.addPoints"
            subheader-translation-path="map.turnOnCoordinates"
          >
          </base-button-subheader>
          <base-button-subheader
            v-else
            @click="turnOffCoordinatesInteraction"
            translation-path="map.finishDraw"
            subheader-translation-path="map.clickToGetCoordinates"
          >
          </base-button-subheader>
        </v-col>
      </v-row>
      <template v-if="cursorPositionCoordinates.length > 0">
        <v-row no-gutters class="pr-9 pl-8 pt-1 align-center">
          <v-col cols="auto">
            <v-subheader class="text-body-1 font--text font-weight-medium" v-text="$i18n.t('map.pointsList')">
            </v-subheader>
          </v-col>
          <v-spacer> </v-spacer>
          <v-col cols="auto">
            <base-rounded-button
              icon="$csv"
              size="x-small"
              color="success"
              @click="saveToCsv"
              :tooltip="$i18n.t('sidebar.exportCoordsToCsv')"
            />
            <dots-menu :items="dotsMenuItems" @delete="clearCoordinatesInteraction"></dots-menu>
          </v-col>
        </v-row>
        <v-row class="px-9 coordinates">
          <v-col>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-center text-body-1 font--text"
                      style="font-size: 14px !important; border: none !important"
                    ></th>
                    <th
                      class="text-center text-body-1 font--text"
                      style="font-size: 14px !important; border: none !important"
                    >
                      X
                    </th>
                    <th
                      class="text-center text-body-1 font--text"
                      style="font-size: 14px !important; border: none !important"
                    >
                      Y
                    </th>
                    <th
                      class="text-center text-body-1 font--text"
                      style="font-size: 14px !important; border: none !important"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="({ x, y, id }, index) in cursorPositionCoordinates" :key="id">
                    <td class="text-body-1 font--text" style="font-size: 12px !important">{{ id }}.</td>
                    <td class="text-body-1 font--text" style="font-size: 12px !important">{{ x }}</td>
                    <td class="text-body-1 font--text" style="font-size: 12px !important">{{ y }}</td>
                    <td class="text-right">
                      <v-icon @click="zoomToCoordinate(id)">mdi-magnify</v-icon>
                      <dots-menu :items="dotsMenuItems" @delete="deleteCoordinate(id, index)"></dots-menu>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { get, sync } from 'vuex-pathify';

import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'Coordinates',
  components: {
    DotsMenu,
  },
  data: () => ({
    dotsMenuItems: [
      {
        name: 'delete',
      },
    ],
  }),
  computed: {
    coordinates: get('map/coordinates'),
    activeTool: get('tools/activeTool'),
    cursorPositionEpsg: get('map/cursorPositionEpsg'),
    isCoordinatesToolActive: sync('tools/toolStatus@isCoordinatesToolActive'),
    cursorPositionCoordinates() {
      return this.coordinates.map(coordinate => {
        const { x, y } = coordinate[this.cursorPositionEpsg];
        return { id: coordinate.id, x: x.toFixed(4), y: y.toFixed(4) };
      });
    },
  },
  methods: {
    addCoordinatesInteraction() {
      this.$root.$emit('coordinates-action', true);
    },
    clearCoordinatesInteraction() {
      this.$root.$emit('coordinates-action', false);
    },
    turnOffCoordinatesInteraction() {
      this.$root.$emit('turnOffCoordinatesInteraction');
    },
    getCsvFileContent() {
      const coordinatesPrecise = this.coordinates.map(coordinate => {
        const { x, y } = coordinate[this.cursorPositionEpsg];
        return { id: coordinate.id, x, y };
      });
      return coordinatesPrecise
        .map(coordinate =>
          Object.keys(coordinate)
            .map(key => coordinate[key])
            .join(',')
        )
        .join('\n');
    },
    getCsvBlobUrl() {
      const fileContent = this.getCsvFileContent();
      const file = new Blob([fileContent], { type: 'text/csv;charset=utf-8;' });
      return URL.createObjectURL(file);
    },
    saveToCsv() {
      this.$_saveFile(this.getCsvBlobUrl(), 'coordinates.csv');
    },
    zoomToCoordinate(id) {
      this.$root.$emit('zoomToFeature', 'coordinates', null, id);
    },
    deleteCoordinate(id, index) {
      this.$store.set('map/DELETE_CLICKED_COORDINATES!', index);
      this.$root.$emit('deleteFeature', 'coordinates', id);
    },
  },
  beforeDestroy() {
    this.clearCoordinatesInteraction();
  },
};
</script>

<style lang="scss" scoped>
.border {
  @include border(bottom);
}
.coordinates {
  max-height: calc(100vh - 370px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
